import React, { useEffect, useRef,useState } from 'react';
import pictoClose from "../assets/images/close.svg";
import ArticleService from "../Map/services/Article";
import {urlDirectus} from "../Map/config/globals";

import $ from "jquery";

export const PopupEdito = ({closePopupEdito}) => {

    //charger les données
    const[articles, setArticles] = useState([]);
    const fetchArticles = async() => {
        try{
            const data = await ArticleService.findAll();
            setArticles(data);
        }catch (error){
            //console.log(error);
        }
    }
    useEffect(() => {
        fetchArticles();
    }, [])

    function showArticle(articleId){
        $('.btn-onglet-edito').removeClass('active');
        $('#ongletArticle'+articleId).addClass('active');

        $('.contenu-onglet-edito').addClass('d-none');
        $('#contenuArticle'+articleId).removeClass('d-none');
    }


    return (
        <div id="infos-edito" className="popup-edito h-100 w-100 bg-dark bg-opacity-75 position-fixed">
            <div className="popup-edito-content rounded-3 px-4 pb-4 bg-white shadow position-fixed overflow-auto">
                <div className="popup-edito-entete position-sticky top-0 bg-white pt-4">
                    <div
                        className="w-100 d-flex align-items-start justify-content-start pb-3 mb-4 border-bottom border-2">
                        <div className="dotted-pattern dotted-pattern-simple"></div>
                        <div className="d-flex flex-column justify-content-center text-start lh-xs px-3">
                            <span className="fw-b fs-5 pb-1">A propos</span>
                            <i className="text-spectral">Inventaire des ressources locales ENSAM</i>
                        </div>
                        <button className="toggle-btn ms-auto">
                            <img src={pictoClose} onClick={closePopupEdito} />
                        </button>
                    </div>
                    <div className="w-100 d-flex align-items-start justify-content-start pb-4 mb-3 overflow-auto">
                        {(() => {

                            if (articles.length > 0) {
                                return (
                                    <>
                                        {
                                            articles.map((art, index) => {
                                                let classNa='';
                                                if(index == 0) classNa='active ';
                                                return (
                                                    <a key={"lien"+index} href="#!" id={"ongletArticle" + index}
                                                       onClick={() => showArticle(index)}
                                                       className={classNa + "btn-onglet-edito text-uppercase fw-b fs-8 lh-lg flex-shrink-0"} dangerouslySetInnerHTML={{__html:art.titre}}></a>
                                                );
                                            })
                                        }
                                        </>
                                    )
                            }
                        })()}
                    </div>
                </div>
                {(() => {
                    if (articles.length > 0) {
                        return (
                            <>
                                {
                                    articles.map((art, index) => {
                                        let classNa='d-none ';
                                        if(index == 0) classNa='';
                                        return (
                                            <div key={"cont"+ index} id={"contenuArticle" + index} className={classNa + "contenu-onglet-edito w-100 d-flex flex-wrap align-items-start"}>
                                                <div className="col-12 col-md-5 col-xxl-3">
                                                    { art.image && <img className="img-fluid h-100 object-fit-contain rounded-3" src={urlDirectus+'assets/'+art.image.id} alt="" /> }
                                                </div>
                                                <div className="col-12 col-md-7 col-xxl-9 ps-md-3 ps-xxl-5 pe-md-3 pe-xl-5 pt-4 pt-md-0" dangerouslySetInnerHTML={{__html:art.contenu}}></div>
                                            </div>
                                        );
                                    })
                                }
                            </>
                        )
                    }
                })()}
            </div>
        </div>
    )
}